"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdTabletop = _interopRequireWildcard(require("cccisd-tabletop"));
var _pageVisitByVisit = _interopRequireDefault(require("./pageVisitByVisit.graphql"));
var _pageVisitByVisitor = _interopRequireDefault(require("./pageVisitByVisitor.graphql"));
var _pageVisitByUrl = _interopRequireDefault(require("./pageVisitByUrl.graphql"));
var _pageVisitVisualization = _interopRequireDefault(require("./pageVisitVisualization.graphql"));
var _pageVisitViz = _interopRequireDefault(require("./pageVisitViz.js"));
var _logTableRenders = _interopRequireDefault(require("../../../helpers/logTableRenders.js"));
var _moment = _interopRequireDefault(require("moment"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var pageVisitTable = function pageVisitTable() {
  var maxDate = (0, _moment["default"])().format('YYYY-MM-DD');
  var minDate = (0, _moment["default"])().subtract(60, 'days').format('YYYY-MM-DD');
  var variables = {
    minDate: minDate,
    maxDate: maxDate
  };
  var byView = {
    query: _pageVisitByVisit["default"],
    rowKey: 'eventId',
    isAscentOrder: false,
    handle: 'pageVisitByVisit',
    visualize: {
      query: _pageVisitVisualization["default"],
      charts: _pageVisitViz["default"],
      variables: variables
    },
    columns: [{
      name: 'eventAt',
      label: 'Visit Date',
      sort: true,
      filter: true,
      filterSettings: {
        type: 'date'
      },
      width: '170px'
    }, {
      name: 'durationSeconds',
      label: 'Time Spent',
      sort: true,
      render: _logTableRenders["default"].durationRender,
      hideInCsv: true
    }, {
      name: 'durationSeconds',
      label: 'Duration (seconds)',
      hideInTable: true
    }, {
      name: 'url',
      label: 'Page',
      sort: true,
      filter: true,
      render: _logTableRenders["default"].linkRender
    }, {
      name: 'pawnId',
      label: 'Visitor ID',
      sort: true,
      filter: true
    }, {
      name: 'pawn.pawn.roleName',
      label: 'Role',
      sort: true,
      filter: true
    }, {
      name: 'pawn.user.username',
      label: 'Username',
      sort: true,
      filter: true
    }]
  };
  var byVisitor = {
    query: _pageVisitByVisitor["default"],
    rowKey: 'pawn.pawnId',
    handle: 'pageVisitByVisitor',
    visualize: {
      query: _pageVisitVisualization["default"],
      charts: _pageVisitViz["default"],
      variables: variables
    },
    columns: [{
      name: 'pawn.pawnId',
      label: 'Visitor ID',
      sort: true,
      filter: true
    }, {
      name: 'pawn.roleName',
      label: 'Role',
      sort: true,
      filter: true
    }, {
      name: 'user.username',
      label: 'Username',
      sort: true,
      filter: true
    }, {
      name: 'eventSummary.duration',
      label: 'Total duration',
      sort: true,
      render: _logTableRenders["default"].durationRender,
      hideInCsv: true
    }, {
      name: 'eventSummary.duration',
      label: 'Duration (seconds)',
      hideInTable: true
    }, {
      name: 'eventCount',
      label: 'Page visits',
      sort: true,
      filter: true
    }, {
      name: 'eventSummary.minDate',
      label: 'First visit',
      width: '170px',
      sort: true,
      filter: true,
      filterSettings: {
        type: 'date'
      }
    }, {
      name: 'eventSummary.maxDate',
      label: 'Latest visit',
      width: '170px',
      sort: true,
      filter: true,
      filterSettings: {
        type: 'date'
      }
    }]
  };
  var byUrl = {
    query: _pageVisitByUrl["default"],
    rowKey: 'value',
    handle: 'pageVisitByUrl',
    visualize: {
      query: _pageVisitVisualization["default"],
      charts: _pageVisitViz["default"],
      variables: variables
    },
    columns: [{
      name: 'value',
      label: 'URL',
      render: _logTableRenders["default"].linkRender,
      sort: true,
      filter: true
    }, {
      name: 'valueCount',
      label: 'Page visits',
      sort: true,
      filter: true
    }, {
      name: 'duration',
      label: 'Total duration',
      render: _logTableRenders["default"].durationRender,
      hideInCsv: true,
      sort: true
    }, {
      name: 'duration',
      label: 'Duration (seconds)',
      hideInTable: true
    }, {
      name: 'minDate',
      label: 'First visit',
      width: '170px',
      filterSettings: {
        type: 'date'
      },
      sort: true,
      filter: true
    }, {
      name: 'maxDate',
      label: 'Latest visit',
      width: '170px',
      filterSettings: {
        type: 'date'
      },
      sort: true,
      filter: true
    }]
  };
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdTabletop["default"], {
    handle: "pageVisits",
    saveState: true,
    views: [{
      handle: 'pagesByView',
      title: 'Page Visits - by Visit',
      table: byView,
      buttons: [_cccisdTabletop.visualizeButton]
    }, {
      handle: 'pagesByVisitor',
      title: 'Page Visits - by Visitor',
      table: byVisitor
    }, {
      handle: 'pagesByUrl',
      title: 'Page Visits - by Url',
      table: byUrl
    }]
  }));
};
var _default = exports["default"] = {
  name: 'visits',
  title: 'Page Visits',
  content: pageVisitTable()
};